export const paginationConfig = {
  align: 'right',
  pageSizes: [100, 200, 300, 500],
  layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
  perfect: true
}